import MaterialDistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-dchain/business-partners-dchain.entity";
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import SalesOrganizationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity";
import ChannelAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import { SalesOrganizationService } from "app/modules/components/configuration/sales-organization/sales-organization.component.service";
import { DistributionChainService } from "app/modules/components/configuration/distribution-chain/distribution-chain.service";
import DistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity";
import { ReplaySubject, Subject, take, takeUntil } from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ICreateMaterialChain } from "./interfaces/create-distribution-chain.interface";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { UserFieldsConfigurationComponent } from "../../configuration/company/user-fields-configuration/user-fields-configuration.component";
import { UserFieldConfigAttributes } from "@albatrosdeveloper/ave-models-package/lib/schemas/fields-catalog/user-field-catalog/user-field-config/user-field-config.entity";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { CompanyFieldCatalogService } from "../../configuration/company/company-form-config/company-form-config.service";
import { UserFieldEntityTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum";

@Component({
  selector: "app-add-material-modal",
  styleUrl: "./distribution-chain.component.scss",
  templateUrl: "./distribution-chain.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    FormSectionComponent,
    UserFieldsConfigurationComponent
  ],
})
export class MaterialDistributionChainComponent {
  currentCreateMaterialChain: ICreateMaterialChain =
    this.initializeCreateMaterial();
  currentUpdateMaterialChain:
    | MaterialDistributionChainAttributes
    | undefined;

  selectedDivisionIds: string[] = [];

  distributionChainList: DistributionChainAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  salesOrganizationList: SalesOrganizationAttributes[] = [];
  channelList: ChannelAttributes[] = [];
  priceList: PriceListAttributes[] = [];
  discountList: PriceListAttributes[] = [];
  allWarehouses: { [key: string]: any[] } = {};

  isEditMode: boolean;
  plants: any[] = [];
  warehouses: any[] = [];

  protected _onDestroy = new Subject<void>();

  fieldsMasterData: UserFieldConfigAttributes[] = [];
  fieldsMasterDataStatus: StatusEnum;

  constructor(
    private readonly companyService: CompanyService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private distributionChainService: DistributionChainService,
    public dialogRef: MatDialogRef<MaterialDistributionChainComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Optional: if you want to pass data,
    private snackBar: MatSnackBar,
    private companyFieldCatalogService: CompanyFieldCatalogService
  ) {
    this.isEditMode = !!data;
    if (this.isEditMode) {
      this.currentCreateMaterialChain = {
        ...data,
        distributionChainId: data._id,
       }
  }
}


  ngAfterViewInit(): void {
    this.fetchAllCompanies();
    this.fetchAllChain();
    this.fetchAllSalesOrganization();
  }

  loadFieldsMasterData(): void {
        this.companyFieldCatalogService.getFieldsMaster(this.companyList[0]._id.toString(), UserFieldEntityTypeEnum.MATERIAL_DISTRIBUTION_CHAIN)
        .pipe(take(1))
        .subscribe({
          next: (res) => {
            this.fieldsMasterDataStatus = res.data.statusId;
            this.fieldsMasterData = res.data.fields;
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error fetching fields master data",
              "Cerrar",
              { duration: 5000 }
            );
          },
        });
      }
      
  private fetchAllChain(): void {
    this.distributionChainService.findToComboBox().subscribe({
      next: (res) => {
        this.distributionChainList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener canales de distribución,","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organizaciones de ventas.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.loadFieldsMasterData();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias","Cerrar",{ duration: 5000});
      },
    });
  }



  private initializeCreateMaterial(): ICreateMaterialChain {
    return {
      distributionChainId: [],
    };
  }


  compareById(item1: any, item2: any): boolean {
    return item1 && item2
      ? item1._id.toString() === item2.toString()
      : item1 === item2;
  }




  save() {
      this.dialogRef.close(this.currentCreateMaterialChain);
  }
}
